import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($data: InvoiceInput!, $project_id: String!){
  updateProjectClientInvoiceProjectReturn(data: $data){
      ${projectFragment}
  }
}`